import { PersonalPermission, PublicRolePermissionInfo, Role, RolePermission } from '@yandex-360/telemost-sdk';

export enum PublicPermissionOverride {
    SUMMARIZATION = 'summarization',
}

export type RolePermissionMatrixSlice = Partial<Record<RolePermission, boolean>>;

export type RolePermissionMatrix = Partial<Record<Role, RolePermissionMatrixSlice>>;

export { Role, RolePermission, PersonalPermission };
export type { PublicRolePermissionInfo };
